import axiosInstance from "@/common/interceptors/axiosInstance";
import type {
  GnnHealthResponse,
  GnnRolloutResponse,
  GnnStatusResponse,
} from "@/types/gnn";

type ApiResponse<T> = { data: T };

export const fetchGnnStatus = async (): Promise<GnnStatusResponse> => {
  const { data } = await axiosInstance.get<ApiResponse<GnnStatusResponse>>(
    "/v1/admin/gnn/status"
  );
  return data.data;
};

export const fetchGnnHealth = async (): Promise<GnnHealthResponse> => {
  const { data } = await axiosInstance.get<ApiResponse<GnnHealthResponse>>(
    "/v1/admin/gnn/health"
  );
  return data.data;
};

export const fetchGnnRollout = async (): Promise<GnnRolloutResponse> => {
  const { data } = await axiosInstance.get<ApiResponse<GnnRolloutResponse>>(
    "/v1/admin/gnn/rollout"
  );
  return data.data;
};
